<template>
  <div class="page-setting-personal-bind">
    <app-page-box title="账号绑定" v-if="currentStep === 0" key="0">
      <el-form class="page-setting-personal-bind__form" :model="form1" :rules="rules" ref="form1" label-width="80px" status-icon>
        <el-form-item size="small">
          <div class="page-setting-personal-bind__tip-label">请输入你已绑定的手机号码</div>
          <span class="page-setting-personal-bind__tip-value">{{ user.cellphone | fuzzyPhone }}</span>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" size="small">
          <el-input type="text" v-model="form1.phone" placeholder="请输入完整的手机号" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha" size="small">
          <div class="page-setting-personal-bind__captcha">
            <el-input type="text" v-model="form1.captcha" placeholder="请输入短信验证码" auto-complete="off"></el-input>
            <el-button type="info" @click.prevent="handleBtnCaptchaClick('form1')" :disabled="countdown > 0" plain>{{ countdown > 0 ? `${countdown}s后重新发送` : '发送验证码' }}</el-button>
          </div>
        </el-form-item>
        <el-form-item size="small">
          <el-button type="primary" @click="handleBtnSubmitClick('form1')">下一步</el-button>
        </el-form-item>
      </el-form>
    </app-page-box>
    <app-page-box title="账号绑定" v-else-if="currentStep === 1" key="1">
      <el-form class="page-setting-personal-bind__form" :model="form2" :rules="rules" ref="form2" label-width="80px">
        <el-form-item size="small">
          <div class="page-setting-personal-bind__tip-label">请输入你的新手机号</div>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" size="small">
          <el-input type="text" v-model="form2.phone" placeholder="请输入新的的手机号" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha" size="small">
          <div class="page-setting-personal-bind__captcha">
            <el-input type="text" v-model="form2.captcha" placeholder="请输入短信验证码" auto-complete="off"></el-input>
            <el-button type="info" @click.prevent="handleBtnCaptchaClick('form2')" :disabled="countdown > 0" plain>{{ countdown > 0 ? `${countdown}s后重新发送` : '发送验证码' }}</el-button>
          </div>
        </el-form-item>
        <el-form-item size="small">
          <el-button type="primary" @click="handleBtnSubmitClick('form2')">下一步</el-button>
        </el-form-item>
      </el-form>
    </app-page-box>
    <app-page-box title="账号绑定" v-else-if="currentStep === 2" key="2">
      <div class="page-setting-personal-bind__success">
        <app-svg-icon icon-class="success"></app-svg-icon>
        <span>完成绑定，新绑定手机号码为：</span>
        <b>{{ form2.phone | fuzzyPhone }}</b>
      </div>
    </app-page-box>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'
import { validateCellphone } from '@/utils'
import api from '@/api'

export default {
  name: 'SettingPersonalBind',
  components: {
    AppPageBox
  },

  data () {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!validateCellphone(value)) {
        callback(new Error('请输入11位正确的手机号'))
      } else {
        callback()
      }
    }

    return {
      timer: null,
      countdown: 0,
      messageType: 3, // 短信验证码类型 1：登录 2：忘记密码 3：修改绑定手机
      currentStep: 0,
      form1: {
        phone: '',
        captcha: ''
      },
      form2: {
        phone: '',
        captcha: ''
      },
      rules: {
        phone: { required: true, validator: validatePhone, trigger: 'change' },
        captcha: { required: true, message: '请输入短信验证码', trigger: 'change' }
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    }
  },

  methods: {
    /**
     * 设置倒计时
     */
    setCountdown () {
      this.countdown = 59
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.countdown-- <= 0) {
          clearInterval(this.timer)
          this.countdown = 0
        }
      }, 1000)
    },

    clearCountdown () {
      clearInterval(this.timer)
      this.countdown = 0
    },

    /**
     * 通过旧的手机号获取短信验证码
     */
    getCodeByOldCellphone (cb) {
      api.accountBind.getCodeByOldCellphone({
        body: {
          messageType: this.messageType,
          phoneNumber: this.form1.phone
        }
      }).then(response => {
        cb && cb(response)
      })
    },

    /**
     * 验证旧的手机号收到的验证码
     */
    verifyOldCellphoneCode (cb) {
      api.accountBind.verifyOldCellphoneCode({
        body: {
          messageCode: this.form1.captcha,
          phoneNumber: this.form1.phone
        }
      }).then(response => {
        cb && cb(response)
      })
    },

    /**
     * 通过新的手机号获取短信验证码
     */
    getCodeByNewCellphone (cb) {
      api.accountBind.getCodeByNewCellphone({
        body: {
          messageType: this.messageType,
          phoneNumber: this.form2.phone
        }
      }).then(response => {
        cb && cb(response)
      })
    },

    /**
     * 验证新的手机号收到的验证码
     */
    verifyNewCellphoneCode (cb) {
      api.accountBind.verifyNewCellphoneCode({
        body: {
          messageCode: this.form2.captcha,
          phoneNumber: this.form2.phone
        }
      }).then(response => {
        cb && cb(response)
      })
    },

    /**
     * 表单提交
     */
    submit (formName, cb) {
      this.$refs[formName].validate(valid => {
        if (valid) cb && cb()
      })
    },

    /**
     * 验证手机号
     */
    checkPhone (formName, cb) {
      this.$refs[formName].validateField('phone', (errorMessage) => {
        if (!errorMessage) cb && cb()
      })
    },

    /**
     * 处理表单提交按钮点击事件
     */
    handleBtnSubmitClick (formName) {
      this.submit(formName, () => {
        if (formName === 'form1') {
          this.verifyOldCellphoneCode(() => {
            this.clearCountdown()
            this.currentStep++
          })
        } else {
          this.verifyNewCellphoneCode(() => {
            this.clearCountdown()
            this.currentStep++
          })
        }
      })
    },

    /**
     * 处理发送验证码按钮的点击事件
     */
    handleBtnCaptchaClick (formName) {
      this.checkPhone(formName, () => {
        this.setCountdown()
        if (formName === 'form1') {
          this.getCodeByOldCellphone()
        } else {
          this.getCodeByNewCellphone()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.page-setting-personal-bind {
  min-height: 100%;
  background-color: #fff;

  &__form {
    width: 450px;
    padding: 30px 0;

    .el-form-item.is-required .el-form-item__label:before {
      font-family: sans-serif;
    }

    .el-button {
      width: 120px;
    }
  }

  &__tip-label {
    color: #999;
    font-size: 14px;
  }

  &__tip-value {
    font-family: sans-serif;
    font-weight: 700;
  }

  &__captcha {
    display: flex;

    .el-input {
      flex: 1;
    }

    .el-button {
      width: 30%;
      margin-left: 10px;
    }

    img {
      width: 80px;
      margin-left: 10px;
      background-color: black;
    }

    > span {
      margin-left: 10px;
      font-size: 12px;

      a {
        color: $primary-color;
      }
    }
  }

  &__success {
    padding: 30px 0;

    .app-svg-icon {
      width: 30px;
      height: 30px;
      color: #67c23a;
    }

    > span {
      margin-left: 10px;
      color: #999;
      font-size: 16px;
    }

    > b {
      color: $primary-color;
      font-size: 20px;
    }
  }
}
</style>
